import Icon from 'veui/components/Icon'
import { IconChevronDown } from 'dls-icons-vue'

Icon.register('chevron-down', IconChevronDown)
